import(/* webpackMode: "eager" */ "/opt/thedesperatetrader/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/thedesperatetrader/src/components/NotFoundSearch.tsx");
